import { useCurrentUser } from "web/hooks/data"
import { formatListOfUsers } from "../common"

export default function Assignees({ assigneeUsers }) {
  const currentUser = useCurrentUser()
  const assignees = formatListOfUsers(assigneeUsers, currentUser)

  if (!assignees) {
    return null
  }

  return <div className="text-sm text-gray-500">Assigned to {assignees}</div>
}
